import { useEffect, useState } from "react";

/** Waiting service worker = a new version is ready. Applying it reloads the app once. */
export function useAppUpdate() {
  const [ready, setReady] = useState(!!window.__bfUpdate);
  useEffect(() => {
    const h = () => setReady(!!window.__bfUpdate);
    window.addEventListener("bf-update-ready", h);
    return () => window.removeEventListener("bf-update-ready", h);
  }, []);

  const applyUpdate = () => {
    const reg = window.__bfUpdate;
    if (!reg?.waiting) return window.location.reload();
    window.__bfReloading = true;
    reg.waiting.postMessage({ type: "SKIP_WAITING" });
  };

  return { updateReady: ready, applyUpdate };
}
